import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const NoticeSection = ({ notices, hideHeader = false }) => {
  const navigate = useNavigate();

  const openNotice = (id) => {
    if (!id) return;
    navigate(`/notice-detail?id=${id}`);
  };

  return (
    <div className="bg-card rounded-lg shadow-gaming-md p-4 md:p-6">
      {!hideHeader ? (
        <div className="flex items-center justify-between mb-4 md:mb-6">
          <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground">
            공지사항
          </h2>
          <Icon name="Megaphone" size={20} color="var(--color-primary)" />
        </div>
      ) : null}

      <div className="space-y-2">
        {(!notices || notices.length === 0) && (
          <div className="p-4 bg-muted/30 rounded-md border border-border/50">
            <p className="text-sm text-muted-foreground caption">공지사항이 없습니다.</p>
          </div>
        )}

        {(notices || []).map((n) => (
          <div
            key={n.id}
            className="p-3 md:p-4 bg-muted/50 rounded-md border border-border/50 cursor-pointer hover:bg-muted transition-gaming"
            onClick={() => openNotice(n.id)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') openNotice(n.id);
            }}
          >
            <div className="flex items-start justify-between gap-3">
              <div className="flex items-start gap-3 min-w-0">
                {n.thumbnailUrl ? (
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-md overflow-hidden bg-background/60 border border-border/50 flex-shrink-0">
                    <img
                      src={n.thumbnailUrl}
                      alt={n.title ? `${n.title} thumbnail` : 'notice thumbnail'}
                      className="w-full h-full object-cover"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                ) : null}

                <div className="min-w-0">
                  <div className="text-sm md:text-base font-medium text-foreground truncate">
                    {n.title}
                  </div>
                  <div className="text-xs text-muted-foreground caption mt-1">
                    {n.date} · {n.authorName || '꿈현공장장'}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

    </div>
  );
};

export default NoticeSection;
